import { bearingDeg, distanceM, type LatLon } from './geo';
import type { Site } from './cluster';
import type { LosStatus } from './los';

export type RankedSite = Site & { distanceM: number; bearing: number; los?: LosStatus };

export const RANK_EXPLANATION = 'Prima i siti con visuale libera, poi i più vicini.';

const ORDER: Record<string, number> = { libera: 0, marginale: 1, undefined: 2, ostruita: 3 };

export function rankSites(home: LatLon, sites: Site[], los: Map<string, LosStatus>, top = 3): Record<string, RankedSite[]> {
  const by: Record<string, RankedSite[]> = {};
  for (const s of sites) {
    const r: RankedSite = { ...s, distanceM: distanceM(home, s), bearing: bearingDeg(home, s), los: los.get(s.id) };
    (by[s.network] ??= []).push(r);
  }
  for (const k of Object.keys(by)) {
    by[k].sort((a, b) => ORDER[String(a.los)] - ORDER[String(b.los)] || a.distanceM - b.distanceM);
    by[k] = by[k].slice(0, top);
  }
  return by;
}
